import { I_SUBSCRIPTION } from '~/src/Entities/Subscription/Subscription.Types'

export type T_SUBSCRIPTION_REDUCER = {
  subscriptions: I_SUBSCRIPTION[]
}

export const INITIAL_STATE: T_SUBSCRIPTION_REDUCER = {
  subscriptions: []
}
